module.exports = __webpack_public_path__ + "static/media/logo-inteco.c242e3cc.png";